export const getIconStyle = (iconType: string, iconStyle: string) => {
  if (iconType === "symbols" && iconStyle === "round") {
    return "rounded";
  } else {
    return iconStyle;
  }
};
